// extracted by mini-css-extract-plugin
module.exports =  {"fields":"tK3cXLqki4shdadqKv_i"};